import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import header from './fr/header.json';
import footer from './fr/footer.json';
import signinpage from './fr/signinpage.json';
import errors from './fr/errors.json';
import maintenance from './fr/maintenance.json';
import secondauthfactor from './fr/secondauthfactorpage.json';
import overviewpage from './fr/overviewpage.json';
import paymentpage from './fr/paymentpage.json';
import confirmationsuccesspage from './fr/confirmationsuccesspage.json';
import confirmationerrorpage from './fr/confirmationerrorpage.json';
import customerportalbox from './fr/customerportalbox.json';
import adyen from './fr/adyen.json';

i18next.use(initReactI18next).init({
  lng: 'fr',
  resources: {
    fr: {
      header,
      footer,
      signinpage,
      errors,
      maintenance,
      secondauthfactor,
      overviewpage,
      paymentpage,
      confirmationsuccesspage,
      confirmationerrorpage,
      customerportalbox,
      adyen,
    },
  },
});

export default i18next;
